import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import diplomats_Campaigner_ENFP_personality_header from '../../images/personality_types_details/diplomats_Campaigner_ENFP_personality_header.svg'
import diplomats_Campaigner_ENFP_conclusion from '../../images/personality_types_details/diplomats_Campaigner_ENFP_conclusion.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const enfp_conclusion = () => {
    return (
        <Layout>
            <main class="q-td analyst campaigner">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/compaigner-enfp-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-careers" className="tab with-progress">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfps-at-work" className="tab with-progress">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-conclusion" className="tab with-progress active">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header diplomat campaigner">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={diplomats_Campaigner_ENFP_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Campaigner</span> Personality</h1>
                        <div class="code">ENFP-A / ENFP-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>
                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/compaigner-enfp-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfps-at-work">Workplace Habits</Link></li>
                                <li className="active"><Link to="/personality-types/compaigner-enfp-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>Conclusion</h1>


                        <p>Few personality types are as creative and charismatic as Campaigners. Known for their idealism and enthusiasm, Campaigners are good at dealing with unexpected challenges and brightening the lives of those around them. Campaigners’ imagination is invaluable in many areas, including their own personal growth.</p>

                        <div class="scene">
                            <img alt="Campaigner personality" src={diplomats_Campaigner_ENFP_conclusion} alt="Campaigner personality" />
                        </div>

                        <p>Yet Campaigners can be easily tripped up in areas where idealism and kindness are more of a liability than an asset. Whether it is finding (or keeping) a partner, staying calm under pressure, reaching dazzling heights on the career ladder or making difficult decisions, Campaigners need to put in a conscious effort to develop their weaker traits and additional skills.</p>

                        <p>What you have read so far is just an introduction into the complex concept that is the Campaigner personality type. You may have muttered to yourself, “wow, this is so accurate it’s a little creepy” or “finally, someone understands me!” You may have even asked “how do they know more about me than the people I’m closest to?”</p>

                        <p>This is not a trick. You felt understood because you were. We’ve studied how Campaigners think and what they need to reach their full potential. And no, we did not spy on you – many of the challenges you’ve faced and will face in the future have been overcome by other Campaigners. You simply need to learn how they succeeded.</p>

                        <p>But in order to do that, you need to have a plan, a personal roadmap. The best car in the world will not take you to the right place if you do not know where you want to go. We have told you how Campaigners tend to behave in certain circumstances and what their key strengths and weaknesses are. Now we need to go much deeper into your personality type and answer “why?”, “how?” and “what if?”</p>

                        <p>This knowledge is only the beginning of a lifelong journey. Are you ready to learn why Campaigners act in the way they do? What motivates and inspires you? What you are afraid of and what you secretly dream about? How you can unlock your true, exceptional potential?</p>

                        <p>Our premium profiles provide a roadmap towards a happier, more successful, and more versatile YOU! They are not for everyone though – you need to be willing and able to challenge yourself, to go beyond the obvious, to imagine and follow your own path instead of just going with the flow. If you want to take the reins into your own hands, we are here to help you.</p>

                        <div class="number">08</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/compaigner-enfps-at-work' className='next-feature'>
                            Workplace Habits
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/' className='next-feature'>
                            Premium Profile
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default enfp_conclusion
